import template from './events.html';
import controller from './events.controller';
import './events.scss';

let eventsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default eventsComponent;



// WEBPACK FOOTER //
// ./client/app/components/events/events.component.js